// transfers
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Blockies from "react-blockies";

import WebbDividerSmall from "../webb/webb-divider-sm";
import WebbDividerMedium from "../webb/webb-divider-md";
import WebbModuleInfo from "../webb/webb-module-info";
import FormNeeded from "../webb/form-needed";
import WebbSpinner from "../webb/webb-spinner-sm";
import ListNoData from "../webb/list-nodata";

import { UserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";
import { GetUserPoapTransfers } from "../../services/srvc-transfers-realm";


export default function PoapListModule() {

  const asset = UserForm() === 'in' ? GetLocalUser() : GetLocalBusiness();
  const [loading, setLoading] = useState(true);

  const [item, setItems] = useState(10); // rows per page
  const [rows, setRows] = useState(0); // total rows
  const [cntr, setCounter] = useState(1); // current page counter
  const [live, setLive] = useState(false); // live stream

  const [data, setData] = useState([]);


  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);
        
        setData ((await GetUserPoapTransfers(({
          data: {usid: asset.usid, item: item, cntr: cntr},
          user: asset.usid
        }))).data)
        
        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid, cntr, item]);


  const handleItem = items => {
    setItems(items)
  }


  const handleCounter = counter => {
    setCounter(counter)
  }


  if (loading){ return ( <> <div className="text-center"><WebbSpinner /></div> </> ) }
  if (!data || data.length === 0) { return ( <> <ListNoData/> </> ) }

  return (
  <>
    {console.log(data)}
    <div className="">
  
    {data && data.map((item, i) => (
        <Link to = {`/u/${item.acnt}`} target={'_blank'} key={i}>
          <div className="d-flex p-3 py-2 bg-wite text-dark rounded-wd mb-3 hilite" >
          
            <div className="mt-1">
              <Blockies seed={item.acnt || 'wise'} className="identicon rounded-circle m-0" size={10} />
            </div>

            <div className='ps-2 mt-1'>
              <p className='fw-bold m-0 text-color-main text-sm'>{item.name}</p>
              <p className='small m-0 text-sm'>{item.emid}</p>
              <p className='small m-0 text-sm'>{item.acnt}</p>
            </div>

          </div>
        
        </Link>

      ))}

    </div>

  </>
  )
}